import usersService from "../services/usersService";



const handleError = (err) => ({
  success: false,
  message: err?.message || "Erreur inattendue.",
});

const usersController = {

     fetchAll: async () => {
        try {
          const data = await usersService.getAll();
          return { success: true, data };
        } catch (err) { return handleError(err); }
      },
    
};
export default usersController;